<template>
  <v-dialog v-model="visible" width="500" @keydown.esc="visible = false" lazy>
    <div v-if="this.initState === 1">
      <v-card>
        <v-card-title class="headline">Completed To-dos</v-card-title>
        <v-divider></v-divider>
        <v-container class="scroll-y completedToDoPnl" id="completedToDoPnl">
          <v-card-text v-if="items.length === 0">
            <v-layout align-center justify-center column>
              You did not complete any To-do
            </v-layout>
          </v-card-text>
          <div v-else v-scroll:#completedToDoPnl="completedToDoScroll">
            <v-list three-line>
              <transition-group name="scale-transition" tag="div">
                <template v-for="(item, index) in items">
                  <div :key="item.id">
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-checkbox color="green" v-model="item.completed" @click="updateToDo(item)"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.description }}</v-list-tile-title>
                        <v-list-tile-sub-title>Completed on {{ formatDateTime(item.completedDate) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < items.length"></v-divider>
                  </div>
                </template>
              </transition-group>
              <v-list-tile v-if="$store.state.widgets.completedToDoList.loadingNewCompletedToDo">
                <v-list-tile-content>
                  <v-list-tile-title class="text-xs-center">
                    <v-progress-circular indeterminate color="primary" :size="15"></v-progress-circular>
                    Loading...
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="$emit('close')">Close</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <loader v-else :card="false" :height="150" :init="doReload" :loading="initState === 0"></loader>
  </v-dialog>
</template>

<script>
import { TODO_COMPLETED_INIT_LOADING, TODO_COMPLETED_INIT_SUCCESS, TODO_COMPLETED_INIT_FAIL, TODO_COMPLETED_UPDATE } from '@/store/types'
import http, { expandURI } from '@/utils/ajax'
import { formatDisplayDateTime } from '@/utils/date'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      scrollable: true,
      visible: false,
      updatedItem: null,
      updatedItemIndex: null
    }
  },
  computed: {
    initState() {
      return this.$store.state.widgets.completedToDoList.init
    },
    items() {
      return this.$store.state.widgets.completedToDoList.tasks
    }
  },
  methods: {
    async init() {
      this.$store.commit(TODO_COMPLETED_INIT_LOADING)
      const apiUrl = this.$store.state.widgets.toDoList.menu.queryCompletedToDo
      if (apiUrl) {
        try {
          const expand = {}
          const result = await http.get(expandURI(apiUrl, expand))
          const menu = extractMenu(result.data._links)
          let commitResult = result.data
          Object.assign(commitResult, {
            menu: menu
          })
          this.$store.commit(TODO_COMPLETED_INIT_SUCCESS, commitResult)
        } catch (error) {
          this.$store.commit(TODO_COMPLETED_INIT_FAIL)
        }
      } else {
        this.$store.commit(TODO_COMPLETED_INIT_FAIL)
      }
    },
    doReload() {
      this.init()
    },
    completedToDoScroll(e) {
      const scrollHeight = e.target.scrollHeight - e.target.offsetHeight
      // Load when is 100px off the bottom
      const heightToLoad = scrollHeight - 100
      const scrollTop = e.target.scrollTop
      if (scrollTop >= heightToLoad) {
        this.$store.dispatch('loadMoreCompletedToDo')
      }
    },
    updateToDo(item) {
      this.updatedItemIndex = this.items.indexOf(item)
      this.updatedItem = item
      const userToDo = {
        id: item.id,
        description: item.description,
        completed: false,
        completedDate: null
      }

      this.$store.commit(TODO_COMPLETED_UPDATE, userToDo)
      // Contact server to update to-do
      const apiUrl = this.$store.state.widgets.toDoList.menu.updateToDo
      if (apiUrl) {
        try {
          const postData = {
            id: userToDo.id,
            description: userToDo.description,
            completed: userToDo.completed,
            completedDate: userToDo.completedDate
          }
          http.put(apiUrl, postData)
        } catch (error) { }
      }
    },
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    }
  },
  watch: {
    'value': function (value) {
      this.visible = value
    },
    'visible': function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      } else {
        // init here
        this.init()
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.completedToDoPnl {
  max-height: 500px;
  width: 500px;
  &.container {
    padding: 0px;
  }
}
</style>
